import React from 'react';
import { motion } from 'framer-motion';
import { FaBriefcase, FaCalendarAlt, FaMapMarkerAlt, FaExternalLinkAlt } from 'react-icons/fa';
import resume from './image/divyanshi tiwari resume updated).pdf';
import './Experience.css';

const Experience = () => {
  const experiences = [
    {
      id: 1,
      title: 'Software Developer',
      company: 'Orbitsys Technologies Pvt.Ltd.',
      location: 'Gurgaon,Haryana',
      period: '2023 - 2024',
      description: 'Leading development of frontend applications using React and modern web technologies. Mentoring junior developers and implementing best practices.',
      achievements: [
        'Led a team of 5 developers in building a scalable frontend platform',
        'Improved application performance by 40% through optimization',
        'Implemented responsive design for all applications',
        'Mentored 3 junior developers and conducted code reviews'
      ],
      technologies: ['React', 'JavaScript', 'CSS3', 'HTML5', 'Material UI' ],
      current: true
    },
    {
      id: 2,
      title: 'Software Developer',
      company: 'ATS Services Pvt.Ltd.',
      location: 'Faridabad,Haryana',
      period: '2022 - 2023',
      description: 'Developed and maintained multiple frontend applications for clients across various industries. Collaborated with design and product teams.',
      achievements: [
        'Built 10+ client websites with 100% client satisfaction',
        'Reduced bug reports by 50% through improved testing',
        'Implemented responsive design for all applications',
        'Collaborated with UX team to improve user experience'
      ],
      technologies: ['React', 'JavaScript', 'CSS3', 'HTML5', 'GitLab' ,'Material UI'],
      current: false
    },
    {
      id: 3,
      title: ' Jr. Software Developer',
      company: 'Curio Ventures',
      location: 'Hyderabad,Telangana',
      period: '2021 - 2022',
      description: 'Focused on creating beautiful and responsive user interfaces. Worked closely with designers to implement pixel-perfect designs.',
      achievements: [
        'Developed 15+ responsive websites and web applications',
        'Achieved 95% accessibility score across all projects',
        'Optimized loading times by 30%',
        'Created reusable component library'
      ],
      technologies: ['React', 'HTML5', 'CSS3', 'JavaScript', 'Figma'],
      current: false
    }
  ];

  const handleResumeDownload = () => {
    const link = document.createElement('a');
    link.href = resume;
    link.download = 'Divyanshi_Tiwari_Resume.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <section id="experience" className="experience section">
      <div className="container">
        <motion.h2
          className="section-title"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          Work Experience
        </motion.h2>
        
        <motion.p
          className="section-subtitle"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          viewport={{ once: true }}
        >
          My professional journey and the companies I've had the pleasure to work with
        </motion.p>

        <div className="experience-timeline">
          {experiences.map((experience, index) => (
            <motion.div
              key={experience.id}
              className={`experience-item ${experience.current ? 'current' : ''}`}
              initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: index * 0.2 }}
              viewport={{ once: true }}
            >
              <div className="experience-card">
                <div className="experience-header">
                  <div className="experience-icon">
                    <FaBriefcase />
                  </div>
                  <div className="experience-info">
                    <h3 className="experience-title">{experience.title}</h3>
                    <div className="experience-company">
                      <span className="company-name">{experience.company}</span>
                      {experience.current && (
                        <span className="current-badge">Current</span>
                      )}
                    </div>
                    <div className="experience-meta">
                      <span className="experience-period">
                        <FaCalendarAlt /> {experience.period}
                      </span>
                      <span className="experience-location">
                        <FaMapMarkerAlt /> {experience.location}
                      </span>
                    </div>
                  </div>
                </div>
                
                <div className="experience-content">
                  <p className="experience-description">{experience.description}</p>
                  
                  <div className="experience-achievements">
                    <h4>Key Achievements:</h4>
                    <ul>
                      {experience.achievements.map((achievement, achievementIndex) => (
                        <li key={achievementIndex}>{achievement}</li>
                      ))}
                    </ul>
                  </div>
                  
                  <div className="experience-technologies">
                    <h4>Technologies Used:</h4>
                    <div className="tech-tags">
                      {experience.technologies.map((tech, techIndex) => (
                        <span key={techIndex} className="tech-tag">
                          {tech}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          className="experience-cta"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
          viewport={{ once: true }}
        >
          <div className="cta-content">
            <h3>Ready to work together?</h3>
            <p>I'm always open to discussing new opportunities and exciting projects.</p>
            <div className="cta-buttons">
              <a href="#contact" className="btn btn-primary">
                Get In Touch
              </a>
              <button 
                onClick={handleResumeDownload}
                className="btn btn-secondary"
              >
                <FaExternalLinkAlt /> View Resume
              </button>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Experience; 